import { Flex, Text } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';
import { useLocalizedCurrencyFormatter } from 'shared/utils/currency';

type PaidByReminderKpiProps = {
  paidThroughCollectionAmount: number;
};

export const PaidByReminderKpi = ({ paidThroughCollectionAmount }: PaidByReminderKpiProps) => {
  const { t } = useTranslation();
  const formatAmount = useLocalizedCurrencyFormatter();

  return (
    <Flex component="figure" align="baseline" gap="xs" m={0}>
      <Text fz="h1" fw={600} lh={1} c="purple.6">
        {formatAmount.format(paidThroughCollectionAmount)}
      </Text>
      <Text component="figcaption" size="xs" c="gray.6">
        {t(i18nKeys.ANALYTICS.PAID_BY_REMINDER.KPI_CAPTION)}
      </Text>
    </Flex>
  );
};
